import { Typography } from 'components/Contentful'
import { Image } from 'components/Image'
import { formatDollar } from './utils'

export const MinimumPaymentsCard = ({ config, result, className }) => (
  <div className={className}>
    <div
      className="lg:p-6 p-3 flex flex-col items-center text-center grow"
      data-testid="DebtPayoffCalculator-min-payments-card-wrapper"
    >
      <div className="min-h-[60px]">
        <Image
          alt={'Alert'}
          height="60"
          src="/MINIMUM.svg"
          width="60"
          className="lg:mt-4 my-2 lg:mb-6"
        />
      </div>
      <Typography
        component="h2"
        className="text-[#1D252F] tracking-normal mb-0 lg:mb-2 font-bold text-[16px] lg:font-medium lg:text-[20px] pb-3 lg:pb-4 leading-[1.2] text-center line-clamp-2 lg:whitespace-normal"
        data-testid="DebtPayoffCalculator-min-payments-card-title"
        content={config?.jsonContent?.title4 || 'Minimum\nPayments⁴'}
      />

      <Typography
        component="span"
        className="text-nowrap bg-[#FFF4F0] text-[#CF264E] text-xs rounded-full font-normal p-3"
        data-testid="DebtPayoffCalculator-min-payments-card-badge"
        content={config?.jsonContent?.badge4 || 'To current creditors'}
      />

      <div
        className="my-6 space-y-4 w-full"
        data-testid="DebtPayoffCalculator-min-payments-card-info"
      >
        <div>
          <Typography
            component="span"
            className="lg:text-xl text-base font-medium text-[#1D252F] flex"
            content={`$${formatDollar(result?.resultMonthly)}/mo`}
          />
          <Typography
            className="text-xs lg:text-[14px] font-normal lg:font-medium text-[#42546B] flex p-1 text-left"
            content={result?.resultMonthlyText || 'Est. monthly payment⁵'}
          />
        </div>
        <div>
          <Typography
            component="span"
            className="lg:text-xl text-base font-medium text-[#1D252F] flex"
            content={`$${formatDollar(result?.resultTotal)}`}
          />
          <Typography
            className="text-xs lg:text-[14px] font-normal lg:font-medium text-[#42546B] flex p-1 text-left"
            content={result?.resultTotalText || 'Est. total debt to pay off⁶'}
          />
        </div>
        <div>
          <Typography
            component="span"
            className="lg:text-xl text-base font-medium text-[#1D252F] flex"
            content={`${result?.resultMonths} months`}
          />
          <Typography
            className="text-xs lg:text-[14px] font-normal lg:font-medium text-[#42546B] flex p-1 text-left"
            content={result?.resultMonthsText || 'Est. time to pay off debt⁷'}
          />
        </div>
      </div>
      {config?.jsonContent?.minimumItemList && (
        <ul className="text-left text-xs text-gray-600 space-y-1.5 list-disc list-inside mt-auto w-full pb-6 pl-0 border-t border-solid border-b-0 border-l-0 border-r-0 border-t-[#E7ECF3] pt-[24px] sm:pt-[35px]">
          {config?.jsonContent?.minimumItemList?.map((item, pos) => {
            return <li key={pos}> {item}</li>
          })}
        </ul>
      )}
    </div>
  </div>
)
